/* istanbul ignore file */
import Zepto from 'zepto-webpack'

/**
 * Injects the given styles into the head
 */
export const injectIntoHead = style => {
  const $tag = Zepto(
    `<style type="text/css" id="kr-base-styles">${style}</style>`
  )
  Zepto('head').prepend($tag)
}

/**
 * Given a CSS time string, return an integer representing the parsed time in
 * milliseconds, based on CSS time format.
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/time
 *
 * @param {string} str
 * @returns {number}
 */
export const parseCssTime = str => {
  if (typeof str !== 'string') return 0
  const m = str.match(/^([+-]?[0-9]+(?:\.[0-9]+)?)(ms|s)$/)
  if (!m) return 0
  let value = parseFloat(m[1])
  const unit = m[2]

  if (unit === 's') {
    value *= 1000
  }

  return value
}

/**
 * Strip "display: none" from inline style.
 * Used to ensure components v-show has priority over merchant provided
 * fields templates.
 *
 * @param {string} style
 * @return {string}
 * @since KJS-6391
 */
export const styleWithoutDisplayNone = style => {
  if (typeof style !== 'string') return style
  return style.replace(/display\s*:\s*none\s*;?/i, '').trim()
}
